import React, { useState } from 'react';
import { UserPlus, Copy, ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from '../../hooks/use-toast';

export default function PromoterBadge({ promoter }) {
  const [copied, setCopied] = useState(false);

  if (!promoter) {
    return (
      <span className="inline-flex items-center gap-1.5 px-2 py-1 rounded-lg bg-gray-100 text-gray-500 text-xs">
        <UserPlus className="w-3.5 h-3.5" />
        Orgánico
      </span>
    );
  }

  const refLink = promoter.ref_link || (promoter.ref_slug ? `?${promoter.ref_slug}` : null);
  const label = promoter.name || `Promotor #${promoter.id}`;

  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const text = refLink || promoter.ref_slug || String(promoter.id);
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast({ title: 'Copiado', description: 'Link de referencia copiado' });
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast({ title: 'Error', description: 'No se pudo copiar', variant: 'destructive' });
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="inline-flex items-center gap-1.5 px-2 py-1 rounded-lg bg-black text-white text-xs font-medium">
        <UserPlus className="w-3.5 h-3.5" />
        {label}
      </span>
      {refLink && (
        <>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-7 w-7 text-gray-400 hover:text-gray-700"
            onClick={handleCopy}
            title="Copiar link de referencia"
          >
            <Copy className="w-3.5 h-3.5" />
          </Button>
          <a
            href={refLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-gray-700 p-1"
            title="Abrir link"
          >
            <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </>
      )}
    </div>
  );
}
